// extracted by mini-css-extract-plugin
export default {"logo":"tgoi6Cfx7ZasfS9JNVIazA=="};